import vision from "../../../assets/image vision.png";
import mision from "../../../assets/mission1.png";
import swiper1 from "../../../assets/swiper1.png";
import target from "../../../assets/target2.png";

// Pillars data
export const pillars = [
  {
    id: 1,
    title: "OBJETIVOS",
    desc: "Disminuir el impacto ambiental y prevenir riesgos que puedan ocasionar o atravesar las empresas u organizaciones. Tenemos como propósito orientar a entidades tanto publicas como privadas en el incremento de la eficiencia de sus productos y servicios, teniendo en cuenta el mercado existente, futuro, el ambiente y su capacidad de producción.",
    img: target,
  },
  {
    id: 2,
    title: "MISIÓN",
    desc: "Somos un equipo profesional de trabajo, buscamos ofrecer las mejores soluciones para nuestros clientes.Ademàs de ello, queremos que nuestros clientes concluyan satisfechos por nuestra labor ante sus necesidades.Queremos ser aliados de nuestros clientes, para poder elaborar sus ideas en proyectos y que los mismos se cumplan.",
    img: mision,
  },
  {
    id: 3,
    title: "VISIÓN",
    desc: "Queremos que el nombre de IMAPRO sea conocido nacional e internacionalmente por ofrecer las mejores calidades de soluciones y servicios de ingeniería.Además de elaborar los estrictos estándares de calidad, tiempo, seguridad y ambiente, proporcionando valor agregado a sus clientes y otras partes interesadas.",
    img: vision,
  },
];

// Hero section data
export const heroData = {
  title: "IMAPRO Argentina",
  subtitle:
    "Somos una consultora especializada en ingeniería civil que realiza inspección, medición y desarrollo de proyectos tanto ambientales como de procesos productivos",
  backgroundImage: swiper1,
};
